import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ColorDisabled, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { DiscountQuantityWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { isDrawerOpen, setDrawer } from "../../../store/slices/global";
import { setSelectedWidget } from "../../../store/slices/widgets";
import { IdPopover } from "../../../utils/IdPopover";
import { MoreMenuWidget } from "../MoreMenuWidget";

import { IgDiscountQuantityWidget } from "./IgDiscountQuantityWidget";

interface QuantityWidgetPreviewProps {
  quantityWidget: DiscountQuantityWidget;
}

export const DiscountQuantityWidgetPreview = ({
  quantityWidget,
}: QuantityWidgetPreviewProps) => {
  const dispatch = useDispatch();
  const isWidgetDrawerOpen = useSelector(isDrawerOpen("widgetAction"));
  const toggleDrawer = () => {
    dispatch(setSelectedWidget(quantityWidget));
    dispatch(setDrawer({ drawer: "widgetAction", open: !isWidgetDrawerOpen }));
  };

  return (
    <Grid container item xs={12} md={12} lg={6} key={quantityWidget.id}>
      <IgPaper sx={{ paddingBottom: "15px", width: "100%" }}>
        <Grid
          item
          container
          direction={"column"}
          rowSpacing={2}
          alignItems={"center"}
        >
          <Grid item container direction={"row"} alignItems={"center"}>
            <Grid item flex={1}>
              <IdPopover id={quantityWidget.id}>
                <IgTypography sx={{ fontSize: "14px", fontWeight: 600 }}>
                  {quantityWidget.name}
                </IgTypography>
              </IdPopover>
            </Grid>
            <Grid item>
              <MoreMenuWidget
                toggleDrawer={toggleDrawer}
                widgetType={"quantityButtons"}
              />
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction={"column"}
            rowSpacing={1}
            justifyContent={"center"}
          >
            <Grid
              item
              container
              direction={"column"}
              rowSpacing={1}
              alignItems={"center"}
            >
              <Grid item textAlign={"center"}>
                <IgDiscountQuantityWidget
                  configType={"desktop"}
                  quantityWidget={quantityWidget}
                />
                <IgTypography>Desktop</IgTypography>
              </Grid>
              <Grid
                item
                sx={{
                  borderTop: `solid 1px ${ColorDisabled.light}`,
                  marginTop: "10px",
                  textAlign: "center",
                }}
              >
                <IgDiscountQuantityWidget
                  configType={"mobile"}
                  quantityWidget={quantityWidget}
                />
                <IgTypography>Mobile</IgTypography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
